export const REMEMBER_EMAIL_FOR_LOGIN = 'UI_REMEMBER_EMAIL_FOR_LOGIN';
export const SET_SUBSCRIPTION_TYPE = 'UI_SET_SUBSCRIPTION_TYPE';
export const SET_SUBSCRIPTION_PLAN = 'UI_SET_SUBSCRIPTION_PLAN';
export const RESET_INITIAL_UPGRADE_PLAN_SLIDER_VALUE = 'RESET_INITIAL_UPGRADE_PLAN_SLIDER_VALUE';
